export default "__VITE_ASSET__DFnojHAI__"